export default __webpack_public_path__ + "static/media/WhatsApp Image 2023-10-16 at 14.36.48.e0542fa5.jpeg";